<template>
<div class="projects">
        <h1 class="sr-only">Pauline Fuchs - Tous mes projets</h1>
       <div class="container">
            <FiltersList />
            <Loader v-if="storeProjects.isLoading" />
            <TransitionGroup
            name="projects"
            tag="ul"
            class="projects-list"
            v-else-if="filteredList.length > 0"
            >
            <ProjectItem :proj="proj" v-for="proj in filteredList" :key="proj.id"/>
               </TransitionGroup>
            <div v-else>Aucun projet disponible.</div>
       </div>
</div>
</template>

<script setup lang="ts">
import Loader from '~/components/elements/Loader.vue';
import ProjectItem from '~/components/projets/ProjectItem.vue';
import FiltersList from '~/components/projets/FiltersList.vue';
import type { Project } from '~/types/projects';
const storeProjects = useStoreProjects();
const storeCategories = useStoreCategories();
const storeFilters = useFiltersStore()


const filteredList = computed(() => {
     let list : Project[];
    if(storeFilters.selectedSlug === 'all' ){
        list = storeProjects.projects;
    }
    else {
    const selectedCategory = storeCategories.categories.find(
      cat => cat.slug === storeFilters.selectedSlug
    );
    if (selectedCategory) {
      list = storeProjects.projects.filter(proj =>{
       return  proj.categories?.includes(selectedCategory.id)
      }
        
      );
    } else {
      list = [];
    }
    }
    return list
})

await useAsyncData("projects", async () => {
  return await storeProjects.fetchProjects();
});
await useAsyncData("categories",async () => {
    return await storeCategories.fetchCategories()
})

useSeoMeta({
  title: `Pauline Fuchs - Mes projets`,
  ogTitle:  `Pauline Fuchs - Mes projets`,
  description:'Je suis directrice artistique, illustratrice et motion designer. À travers mes projets, j’explore des sujets culturels, écologiques et scientifiques pour créer des images vivantes, sensibles et engagées.',
  ogDescription: 'Dans mes projets, j’allie illustration et motion design pour donner vie à des sujets qui me tiennent à cœur : culture, écologie, vulgarisation scientifique. J’aime créer des univers graphiques sensibles, texturés et poétiques, où l’information devient claire, humaine et immersive.',
  ogImage: '/hero-photo.png',
})



</script>

<style lang="scss">

.projects{
    padding: 50px;
    @media screen and (max-width:1035px) {
    padding: 15px;
  }
    .loading{
        height:60vh;
        display: flex;
        align-items: center;
        justify-content: center;

    }
    .projects-list{
        display: flex;
        list-style-type: none;
        flex-wrap: wrap;    
        gap: 20px;
        min-height: 50vh;
        margin-top: 2rem;
    }

    .projects-enter-active,
    .projects-leave-active {
        transition: all 0.4s ease;
    }

    .projects-move {
        transition: transform 0.4s ease;
    }

    .projects-enter-from {
        opacity: 0;
        transform: scale(0.95) translateY(15px);
    }

    .projects-leave-to {
        opacity: 0;
        transform: scale(0.95) translateY(-15px);
    }

    .projects-leave-active {
        position: absolute; 
    }
}
    
</style>